module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Bancas presididas")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm5": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Pesquisar",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-title', [_c('exam-filters', {
    attrs: {
      "options": ['semester', 'course'],
      "can-select-any-course": true,
      "semester-required": true
    },
    model: {
      value: (_vm.filters),
      callback: function($$v) {
        _vm.filters = $$v
      },
      expression: "filters"
    }
  })], 1), _vm._v(" "), (_vm.auth.user.roles.includes('admin')) ? _c('v-card-actions', [_c('router-link', {
    attrs: {
      "to": {
        name: 'examRecord'
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "info",
      "dark": "",
      "title": "Registrar banca finalizada de modo manual"
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "light": ""
    }
  }, [_vm._v("description")]), _vm._v(" Registrar banca finalizada (manual)\n            ")], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "search": _vm.search,
      "pagination": _vm.pagination,
      "total-items": _vm.totalItems,
      "loading": _vm.loading,
      "no-data-text": _vm.noData,
      "no-results-text": _vm.noResult,
      "rows-per-page-text": _vm.rowsPerPageT
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          class: _vm.getExamRowClass(props.item)
        }, [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', _vm._l((props.item.studentName), function(item) {
          return _c('p', [_vm._v(_vm._s(item))])
        }), 0), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(props.item.date, 'DD/MM/YYYY')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.hour))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.place))]), _vm._v(" "), _c('td', [_c('v-chip', {
          class: [_vm.getExamStatusClass(props.item), 'white--text'],
          attrs: {
            "small": ""
          }
        }, [_vm._v("\n                        " + _vm._s(_vm.getExamStatus(props.item)) + "\n                    ")])], 1), _vm._v(" "), _c('td', [_c('v-btn', {
          attrs: {
            "color": "orange",
            "floating": "",
            "small": "",
            "dark": "",
            "fab": "",
            "title": "Registrar e certificar presença dos participantes"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.showExamAttendance(props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("playlist_add_check")])], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "cyan darken-1",
            "floating": "",
            "small": "",
            "dark": "",
            "fab": "",
            "title": "Ver fichas de avaliação"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.showExamEvaluation(props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("gavel")])], 1), _vm._v(" "), (!props.item.finalScore || props.item.finalScore == 0) ? _c('router-link', {
          attrs: {
            "to": {
              name: 'examDetail',
              params: {
                id: props.item.id
              }
            }
          }
        }, [_c('v-btn', {
          attrs: {
            "color": "success",
            "floating": "",
            "small": "",
            "dark": "",
            "fab": "",
            "title": "Encerrar banca"
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("school")])], 1)], 1) : _vm._e(), _vm._v(" "), (props.item.finalScore > 0) ? _c('router-link', {
          attrs: {
            "to": {
              name: 'examDetail',
              params: {
                id: props.item.id
              }
            }
          }
        }, [_c('v-btn', {
          attrs: {
            "color": "info",
            "floating": "",
            "small": "",
            "dark": "",
            "fab": "",
            "title": "Ver banca"
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("description")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "grey darken-2",
            "floating": "",
            "small": "",
            "dark": "",
            "fab": "",
            "title": "Emitir documentos"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.showExamDocuments(props.item)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("folder")])], 1)], 1)])]
      }
    }])
  }), _vm._v(" "), _c('v-card-text', [_c('p', {
    staticClass: "pa-1 mb-0"
  }, [_vm._v("Acima estão listadas as bancas que você participa como presidente.")]), _vm._v(" "), _c('p', {
    staticClass: "green lighten-4 pa-1 mb-0"
  }, [_vm._v("Bancas realizadas hoje são exibidas com destaque "), _c('strong', {
    staticClass: "green--text"
  }, [_vm._v("verde")]), _vm._v(".")])]), _vm._v(" "), _c('fullscreen-spinner'), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "lazy": ""
    },
    model: {
      value: (_vm.evaluationDialog),
      callback: function($$v) {
        _vm.evaluationDialog = $$v
      },
      expression: "evaluationDialog"
    }
  }, [_c('exam-evaluations', {
    attrs: {
      "exam-id": _vm.selectedExam
    }
  }, [_c('template', {
    slot: "actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.evaluationDialog = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 2)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "lazy": ""
    },
    model: {
      value: (_vm.attendanceDialog),
      callback: function($$v) {
        _vm.attendanceDialog = $$v
      },
      expression: "attendanceDialog"
    }
  }, [_c('exam-attendance', {
    attrs: {
      "exam-id": _vm.selectedExam
    }
  }, [_c('template', {
    slot: "actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.attendanceDialog = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 2)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "lazy": ""
    },
    model: {
      value: (_vm.documentsDialog),
      callback: function($$v) {
        _vm.documentsDialog = $$v
      },
      expression: "documentsDialog"
    }
  }, [_c('exam-documents', {
    attrs: {
      "exam-id": _vm.selectedExam
    }
  }, [_c('template', {
    slot: "actions"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        _vm.documentsDialog = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6dc51653"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExamChairList.vue
// module id = 252
// module chunks = 0